import { createSelector } from 'reselect';
import { GeneralEnterprise, GeneralUser } from '@mews-commander/data-access';
import { CommanderThunkAction } from '@mews-commander/types';
import { getProp } from '@mews/fp';
import { getCurrentEnterprise } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { getCurrentEnterpriseSubscriptionCode } from '@mews-commander/legacy-entities/src/selectors/session/subscription';

const getEnterpriseCustomFields = (enterprise: GeneralEnterprise) => ({
    /** @deprecated Use enterpriseId instead */
    id: enterprise.id,
    /** @deprecated Use enterpriseName instead */
    name: enterprise.name,
    chainId: enterprise.chainId,
    enterpriseId: enterprise.id,
    enterpriseName: enterprise.name,
    uniqueName: enterprise.uniqueName,
    subscriptionId: enterprise.subscriptionId,
    cityId: enterprise.cityId,
    defaultCultureName: enterprise.defaultCultureName,
    defaultCurrencyCode: enterprise.defaultCurrencyCode,
    defaultLanguageCode: enterprise.defaultLanguageCode,
    legalEnvironmentCode: enterprise.legalEnvironmentCode,
    taxEnvironmentCode: enterprise.taxEnvironmentCode,
    timeZoneIdentifier: enterprise.timeZoneIdentifier,
    enterpriseCountryCode: enterprise?.address?.countryCode,
});

export const getFeatureFlagUserConfiguration = createSelector(
    getProp<boolean>()('isAuthorized'),
    getProp<GeneralUser>()('currentUser'),
    getCurrentEnterprise,
    getCurrentEnterpriseSubscriptionCode,
    (authorized, currentUser, currentEnterprise: GeneralEnterprise, subscriptionCode: number) => ({
        ...(authorized ? { email: currentUser.email } : {}),
        anonymous: true,
        custom: {
            subscriptionCode,
            ...getEnterpriseCustomFields(currentEnterprise),
        },
        country: currentEnterprise?.address?.countryCode,
    })
);

export const setFeatureFlagServiceUser =
    (props: { isAuthorized: boolean; currentUser: GeneralUser }): CommanderThunkAction =>
    async (_dispatch, getState, { featureFlagService }) => {
        const user = getFeatureFlagUserConfiguration(getState(), props);
        // @ts-expect-error
        return featureFlagService.setUser(user);
    };
